import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db40390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static.knowledge.xag.cn/img/h5-notice/aftersale-settlement260403.png",
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'aftersale-settlement',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})